// FETCH ALL SIZE MEASUREMENT DETAILS
export const FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST = 'FETCH_SIZE_MEASUREMENT_DETAILS_REQUEST';
export const FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS = 'FETCH_SIZE_MEASUREMENT_DETAILS_SUCCESS';
export const FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE = 'FETCH_SIZE_MEASUREMENT_DETAILS_FAILURE';

// FETCH ALL SIZE MEASUREMENT DETAILS
export const FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST = 'FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_REQUEST';
export const FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS = 'FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_SUCCESS';
export const FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE = 'FETCH_SIZE_MEASUREMENT_DETAILS_WITHOUT_ID_FAILURE';

// CREATE SIZE MEASUREMENT DETAILS
export const CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST = 'CREATE_SIZE_MEASUREMENT_DETAILS_REQUEST';
export const CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS = 'CREATE_SIZE_MEASUREMENT_DETAILS_SUCCESS';
export const CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE = 'CREATE_SIZE_MEASUREMENT_DETAILS_FAILURE';

// UPDATE SIZE MEASUREMENT DETAILS
export const UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST = 'UPDATE_SIZE_MEASUREMENT_DETAILS_REQUEST';
export const UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS = 'UPDATE_SIZE_MEASUREMENT_DETAILS_SUCCESS';
export const UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE = 'UPDATE_SIZE_MEASUREMENT_DETAILS_FAILURE';

// FETCH SINGLE STATE OF SIZE MEASUREMENT DETAILS
export const FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST = 'FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_REQUEST';
export const FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS = 'FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_SUCCESS';
export const FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE = 'FETCH_SINGLE_SIZE_MEASUREMENT_DETAILS_FAILURE';

// DELETE SIZE MEASUREMENT DETAILS
export const DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST = 'DELETE_SIZE_MEASUREMENT_DETAILS_REQUEST';
export const DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS = 'DELETE_SIZE_MEASUREMENT_DETAILS_SUCCESS';
export const DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE = 'DELETE_SIZE_MEASUREMENT_DETAILS_FAILURE';

// FETCH ALL MEASUREMENT DETAILS
export const FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_REQUEST = 'FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_REQUEST';
export const FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS = 'FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_SUCCESS';
export const FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_FAILURE = 'FETCH_PROPERTY_DATA_FOR_SIZE_DETAILS_MASTER_FAILURE';

export const RESET_SIZE_MEASUREMENT_DETAILS_INFO = 'RESET_SIZE_MEASUREMENT_DETAILS_INFO';

export const CREATE_SIZE_MEASUREMENT_DETAILS_FORM = 'CREATE_SIZE_MEASUREMENT_DETAILS_FORM';

export const UPDATE_SIZE_MEASUREMENT_DETAILS_FORM = 'UPDATE_SIZE_MEASUREMENT_DETAILS_FORM';

export const COPY_FOR_ALL_SIZES_VAR = 'COPY_FOR_ALL_SIZES_VAR';

export const ALL_SIZES_LOADING = 'ALL_SIZES_LOADING';
